import React, { useState } from "react";
import MainLayout from "../components/layout/MainLayout";
import CityList from "../features/cities/CityList";
import CityForm from "../features/cities/CityForm";
import { useNotification } from "../context/NotificationContext";
import cityService from "../services/cityService";

const Cities = () => {
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const { showSuccess } = useNotification();

  const handleCreate = () => {
    setShowForm(true);
  };

  const handleFormSubmit = async (formData) => {
    try {
      setLoading(true);
      const response = await cityService.createCity(formData);
      if (response.success) {
        showSuccess("City created successfully!");
        setShowForm(false);
        setRefreshTrigger((prev) => prev + 1);
      }
    } catch (error) {
      console.error("Form submission error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleFormCancel = () => {
    setShowForm(false);
  };

  return (
    <MainLayout>
      <div className="cities-page">
        {/* Page Header */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h1 className="h3 mb-1 fw-bold text-dark">City Management</h1>
            <p className="text-muted mb-0">Manage cities for location data</p>
          </div>
          <button className="btn btn-primary" onClick={handleCreate}>
            <i className="fas fa-plus me-2"></i>
            Add City
          </button>
        </div>

        {/* Form Modal */}
        {showForm && (
          <div
            className="modal show d-block"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    <i className="fas fa-city me-2"></i>
                    Add New City
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleFormCancel}
                    disabled={loading}
                  ></button>
                </div>
                <div className="modal-body">
                  <CityForm
                    onSubmit={handleFormSubmit}
                    onCancel={handleFormCancel}
                    loading={loading}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Cities List */}
        <CityList refreshTrigger={refreshTrigger} />
      </div>
    </MainLayout>
  );
};

export default Cities;
